import React from 'react';

const BreadCrumb = (props) => {
    return (
        <>
            <h1 className="mt-4">Host Panel</h1>
            <ol className="breadcrumb mb-4">
                <li className="breadcrumb-item active">{props.title}</li>
            </ol>
        </>
    );
};

export default BreadCrumb;
